import { api } from './client';

export const AssetsAPI = {
  list: () => api.get('/assets'), // { status, data: Asset[] }
  publicDetails: (assetId) => api.get(`/public/assets/${encodeURIComponent(assetId)}`),
  recordPublicQrScan: (assetId) => api.post(`/public/assets/${encodeURIComponent(assetId)}/qr-scan`),
  publicAuditSelfScan: (assetId, payload) => {
    if (payload instanceof FormData) {
      return api.post(`/public/assets/${encodeURIComponent(assetId)}/audit-self-scan`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return api.post(`/public/assets/${encodeURIComponent(assetId)}/audit-self-scan`, payload);
  },
  publicMaintenanceRequest: (assetId, payload) => api.post(`/public/assets/${encodeURIComponent(assetId)}/maintenance-request`, payload),
  geofenceLock: (id, payload) => api.post(`/assets/${id}/geofence-lock`, payload),
  publicGeofenceLock: (assetId, payload) => api.post(`/public/assets/${encodeURIComponent(assetId)}/geofence-lock`, payload),
  create: (payload) => api.post('/assets', payload),
  update: (id, payload) => api.patch(`/assets/${id}`, payload),
  transferCustody: (id, payload) => api.patch(`/assets/${id}/transfer-custody`, payload),
  uploadImages: (id, formData) => api.post(`/assets/${id}/images`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  replaceImage: (id, formData) => api.post(`/assets/${id}/images/replace`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  removeImage: (id, payload) => api.delete(`/assets/${id}/images`, { data: payload }),
  delete: (id) => api.delete(`/assets/${id}`),
  bulkDelete: (ids) => api.post('/assets/bulk-delete', { ids }),
  assignToDevice: (id, deviceId) => api.post(`/assets/${id}/assign/${deviceId}`),
  unassign: (id) => api.post(`/assets/${id}/assign/null`),
  disposal: (id) => api.get(`/assets/${id}/disposal`),
  retire: (id, payload) => api.post(`/assets/${id}/retire`, payload),
  dispose: (id, payload) => api.post(`/assets/${id}/dispose`, payload),
  uploadDisposalEvidence: (id, files) => {
    const formData = new FormData();
    Array.from(files || []).forEach((file) => formData.append("files", file));
    return api.post(`/assets/${id}/disposal-evidence`, formData, { headers: { "Content-Type": "multipart/form-data" } });
  },
  downloadDisposalCertificate: (id) => api.get(`/assets/${id}/disposal-certificate`, { responseType: "blob" }),
  deviceAsset: (deviceId) => api.get(`/devices/${deviceId}/asset`),
  downloadTemplate: () => api.get('/assets/bulk-template', { responseType: 'blob' }),
  bulkUpload: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/assets/bulk-upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};
